/**
 * App — Surface Layer (/01)
 *
 * The product entry: the TanStack Router (the `routes/` tree rendered
 * inside the SurfaceShell) wrapped in the server-state (TanStack Query)
 * and theme (CarbonSurfaceThemeProvider) providers.
 *
 * The legacy `rebuilt/RebuiltSurface.tsx` monolith is retained ONLY as a
 * visual reference and is no longer the app entry.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { CarbonSurfaceThemeProvider } from '@theme/CarbonSurfaceThemeProvider';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// REQ-001.91 M2 — no mock tenant theme at the root. Start from the honest g100 default
// (initialTenant=null); the REAL tenant theme override is resolved live from user settings /
// RemoteUsersDatabase inside the surface (never a frozen mock override presented as the tenant's).
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CarbonSurfaceThemeProvider initialTenant={null}>
        <RouterProvider router={router} />
      </CarbonSurfaceThemeProvider>
    </QueryClientProvider>
  );
}
